import TaskManagerEditDto from './TaskManagerEditDto';

export class MeasurementMergeTaskEditDto extends TaskManagerEditDto {
	constructor() {
		super();

		/** @type {number[]} */
		this.inputMeasurements = null;

		/** @type {number} */
		this.outputMeasurement = null;

		/** @type {boolean} */
		this.deleteTimeFromTs = null;

		/** @type {boolean} */
		this.skipRowsWithNullValues = null;

		/** @type {boolean} */
		this.addOrUpdate = null;

		/** @type {boolean} */
		this.deleteFromOutput = null;

		/** @type {number} */
		this.optimizationPipelineLog = null;
	}

	/**
	 * @typedef {Object} _MeasurementMergeTaskEditDtoProps
	 * @property {number[]} inputMeasurements
	 * @property {number} outputMeasurement
	 * @property {boolean} deleteTimeFromTs
	 * @property {boolean} skipRowsWithNullValues
	 * @property {boolean} addOrUpdate
	 * @property {boolean} deleteFromOutput
	 * @property {number} optimizationPipelineLog
	 *
	 * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _MeasurementMergeTaskEditDtoProps} MeasurementMergeTaskEditDtoProps
	 */
	/**
	 *
	 * @param {MeasurementMergeTaskEditDtoProps} props
	 * @returns {MeasurementMergeTaskEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.inputMeasurements = props.inputMeasurements !== null ? props.inputMeasurements : [];
		this.outputMeasurement = props.outputMeasurement;
		this.deleteTimeFromTs = props.deleteTimeFromTs || false;
		this.skipRowsWithNullValues = props.skipRowsWithNullValues || false;
		this.addOrUpdate = props.addOrUpdate || false;
		this.deleteFromOutput = props.deleteFromOutput || false;
		this.optimizationPipelineLog = props.optimizationPipelineLog;

		return this;
	}
}

export default MeasurementMergeTaskEditDto;